import axios from "../utils/axios";

// SHER-263 — Clinical Summary read service.
//
// Reads the server's precomputed, per-patient Clinical Summary (a write-time,
// deduped cache keyed by survey-field type). The banner consumes this object
// directly — there is no client-side scan of the clinical history.

export interface ClinicalSummaryParameter {
    // Distinct values entered across the patient's submissions for this parameter.
    values: string[];
    // True only when the parameter was reviewed with no real value (e.g. allergy
    // NAMC sentinel) and there are no real values. Real values always supersede.
    noKnown?: boolean;
}

export interface ClinicalSummary {
    [parameter: string]: ClinicalSummaryParameter;
}

export interface IGetClinicalSummaryResponse {
    status: number;
    clinicalSummary: ClinicalSummary;
}

export function getClinicalSummaryService(
    uuidInvestigation: string,
    uuidPatient: string,
): Promise<IGetClinicalSummaryResponse> {
    return new Promise((resolve, reject) => {
        axios
            .get(
                import.meta.env.VITE_APP_API_URL +
                    "/researcher/investigation/" + uuidInvestigation +
                    "/patient/" + uuidPatient + "/clinical-summary",
                { headers: { "Authorization": localStorage.getItem("jwt") } },
            )
            .then((response) => {
                if (response.status === 200) {
                    resolve(response.data);
                    return;
                }
                reject(response.data);
            })
            .catch((error) => {
                reject(error);
            });
    });
}
